import { useNavigate } from "react-router-dom";
import primaryComponents from "..";
import { AngleLeft } from "../../../assets/svgIcons";

export const BackButton = ({
  text = "Back",
  onClick = null,
  style = {},
  ...rest
}) => {
  const navigate = useNavigate();

  return (
    <primaryComponents.Button
      type="button"
      classNames={"btn btn--outline"}
      onClick={() => {
        if (onClick) return onClick();
        navigate(-1);
      }}
      style={{ ...style }}
      {...rest}
    >
      <AngleLeft className="mr-1" />
      {text}
    </primaryComponents.Button>
  );
};
